export type ColorPalette =  'primary' | 'secondary' | 'success' | 'warning' | 'error' |
                            'dark-gray' | 'medium-gray' | 'light-gray' | 'white' | 'black';

export enum ColorPaletteValues {
  primary     = 'primary',
  secondary   = 'secondary',
  success     = 'success',
  warning     = 'warning',
  error       = 'error',
  darkGray    = 'dark-gray',
  mediumGray  = 'medium-gray',
  lightGray   = 'light-gray',
  white       = 'white',
  black       = 'black'
}

